import PropTypes from 'prop-types';

import { IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN } from 'constants/theme';

export function CannedGoods({ brand, isActive, width }) {
    const activeColor = brand === MISFITS_THEME_DOMAIN ? '#D7E1B8' : '#F0D3E3';
    const canBodyColor = brand === MISFITS_THEME_DOMAIN ? '#F2EBD1' : '#ECE7E4';
    const canLidColor = brand === MISFITS_THEME_DOMAIN ? '#F2EBD1' : '#ECE7E4';
    const tomatoColor = brand === MISFITS_THEME_DOMAIN ? '#AB363A' : '#CE3935';
    const centerColor = brand === MISFITS_THEME_DOMAIN ? '#A9C580' : '#BCD975';

    return isActive ? (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_6378_2234)">
                <path
                    d="M14.6505 28.7652C21.902 26.9646 29 22.6358 29 14.9992C29 7.3625 22.9452 2.7363 14.6505 1.1728C7.31233 -0.213857 2.48978 6.96057 1.13553 14.967C-0.132106 22.475 7.73356 30.4815 14.6505 28.7652Z"
                    fill={activeColor}
                />
                <path
                    d="M7.51001 10.9233L11.3231 25.154C11.6592 26.4084 14.6093 26.704 17.9122 25.819C21.2152 24.934 23.6222 23.2029 23.2861 21.9486L19.473 7.71787"
                    fill={canBodyColor}
                />
                <path
                    d="M7.51001 10.9233L11.3231 25.154C11.6592 26.4084 14.6093 26.704 17.9122 25.819C21.2152 24.934 23.6222 23.2029 23.2861 21.9486L19.473 7.71787"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M14.0991 11.5884C17.4026 10.7033 19.8085 8.97042 19.473 7.718C19.1374 6.46558 16.1873 6.16786 12.8838 7.05303C9.58035 7.93819 7.17439 9.67105 7.50997 10.9235C7.84556 12.1759 10.7956 12.4736 14.0991 11.5884Z"
                    fill={tomatoColor}
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M22.4876 18.969C22.8237 20.2233 20.4167 21.9544 17.1137 22.8394C13.8107 23.7244 10.8607 23.4288 10.5246 22.1744L8.30835 13.9033C8.64445 15.1577 11.5945 15.4533 14.8975 14.5683C18.2004 13.6833 20.6074 11.9522 20.2713 10.6978L22.4876 18.969Z"
                    fill="white"
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M19.3647 8.49233C20.013 7.36944 18.1375 5.07292 15.1757 3.36291C12.2138 1.6529 9.28724 1.17695 8.63894 2.29984C7.99064 3.42273 9.86612 5.71925 12.8279 7.42926C15.7898 9.13927 18.7164 9.61522 19.3647 8.49233Z"
                    fill={canLidColor}
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M17.9405 7.67025C18.2537 7.12779 16.7442 5.66995 14.5689 4.41406C12.3936 3.15817 10.3764 2.57982 10.0632 3.12228C9.74998 3.66474 11.2595 5.12259 13.4348 6.37848C15.61 7.63436 17.6273 8.21271 17.9405 7.67025Z"
                    fill={canLidColor}
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M16.7761 21.5797C18.3734 21.1517 19.3982 19.7968 19.065 18.5534C18.7319 17.3101 17.1669 16.6491 15.5696 17.0771C13.9723 17.5051 12.9476 18.86 13.2807 20.1033C13.6139 21.3467 15.1788 22.0076 16.7761 21.5797Z"
                    fill={tomatoColor}
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
                <path
                    d="M15.508 15.8608L15.8878 16.4459L16.5616 16.2653C16.8135 16.1978 17.0042 16.4931 16.8412 16.6953L16.4046 17.235L16.7844 17.8201C16.9257 18.0406 16.7047 18.3111 16.4624 18.2175L15.8144 17.9685L15.3778 18.5081C15.2148 18.7103 14.8881 18.5865 14.9002 18.325L14.9366 17.6283L14.2886 17.3793C14.0463 17.2857 14.0638 16.9346 14.3158 16.8671L14.9895 16.6866L15.0259 15.9899C15.0381 15.7284 15.3777 15.6374 15.5189 15.8578L15.508 15.8608Z"
                    fill={centerColor}
                    stroke="#231F20"
                    strokeWidth="0.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_6378_2234">
                    <rect width="30" height="30" fill="white" />
                </clipPath>
            </defs>
        </svg>
    ) : (
        <svg width={width} viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M8 6.65381V23.3077C8 24.7756 11.1346 25.9615 15 25.9615C18.8654 25.9615 22 24.7756 22 23.3077V6.65381"
                fill={canBodyColor}
            />
            <path
                d="M8 6.65381V23.3077C8 24.7756 11.1346 25.9615 15 25.9615C18.8654 25.9615 22 24.7756 22 23.3077V6.65381"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15 9.30769C18.866 9.30769 22 8.11952 22 6.65385C22 5.18817 18.866 4 15 4C11.134 4 8 5.18817 8 6.65385C8 8.11952 11.134 9.30769 15 9.30769Z"
                fill={canLidColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M22 19.8206C22 21.2885 18.8654 22.4744 15 22.4744C11.1346 22.4744 8 21.2821 8 19.8206V10.1411C8 11.6091 11.1346 12.795 15 12.795C18.8654 12.795 22 11.6091 22 10.1411V19.8206Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.9999 7.93617C17.8392 7.93617 20.1409 7.36218 20.1409 6.65412C20.1409 5.94606 17.8392 5.37207 14.9999 5.37207C12.1606 5.37207 9.85889 5.94606 9.85889 6.65412C9.85889 7.36218 12.1606 7.93617 14.9999 7.93617Z"
                fill={canLidColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.9999 21.0002C16.8691 21.0002 18.3845 19.8206 18.3845 18.3656C18.3845 16.9105 16.8691 15.731 14.9999 15.731C13.1306 15.731 11.6152 16.9105 11.6152 18.3656C11.6152 19.8206 13.1306 21.0002 14.9999 21.0002Z"
                fill={tomatoColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M15.2884 14.3849L15.532 15.1349H16.3204C16.6153 15.1349 16.7371 15.5131 16.4999 15.6862L15.8653 16.1477L16.1089 16.8977C16.1986 17.1798 15.8781 17.4105 15.6409 17.2374L15.0063 16.7759L14.3717 17.2374C14.1345 17.4105 13.814 17.1798 13.9038 16.8977L14.1473 16.1477L13.5127 15.6862C13.2755 15.5131 13.3973 15.1349 13.6922 15.1349H14.4807L14.7243 14.3849C14.814 14.1028 15.2114 14.1028 15.3012 14.3849H15.2884Z"
                fill={centerColor}
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

CannedGoods.propTypes = {
    brand: PropTypes.oneOf([IMPERFECT_THEME_DOMAIN, MISFITS_THEME_DOMAIN]).isRequired,
    isActive: PropTypes.bool,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

CannedGoods.defaultProps = {
    isActive: false,
    width: 30,
};
